import { DateTime } from "luxon";

export const getDefaultRange = (periodType: string) => {
  const now = DateTime.now();
  switch (periodType) {
    case "L7D":
      return {
        startDate: now.minus({ days: 7 }).toJSDate(),
        endDate: now.minus({ days: 1 }).toJSDate(),
      };
    case "L30D":
      return {
        startDate: now.minus({ days: 30 }).toJSDate(),
        endDate: now.minus({ days: 1 }).toJSDate(),
      };
    case "L90D":
      return {
        startDate: now.minus({ days: 90 }).toJSDate(),
        endDate: now.minus({ days: 1 }).toJSDate(),
      };
    case "YTD":
      return {
        startDate: now.startOf("year").toJSDate(),
        endDate: now.minus({ days: 1 }).toJSDate(),
      };
    case "L180D":
    default:
      return {
        startDate: now.minus({ days: 180 }).toJSDate(),
        endDate: now.minus({ days: 1 }).toJSDate(),
      };
  }
};
